import { Injectable, computed, inject, signal } from '@angular/core';
import { FirestoreService } from './firestore.service';
import { Estadistica } from '../models/estadistica.interface';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class EstadisticasService {
    private firestoreService = inject(FirestoreService);
    private _estadisticas = signal<Estadistica | null>(null);
    readonly estadisticasSignal = computed(() => this._estadisticas());


    public cargarEstadisticas() {
        try {
            this.firestoreService.listenDoc<Estadistica>('estadisticas', 'estadisticasGenerales', estadisticas => {
                this._estadisticas.set(estadisticas);
            });
        } catch (error) {
            console.error('[EstadisticasService] Error escuchando estadísticas generales:', error);
        }
    }

    // ➡️ Setear un campo manualmente
    async setearCampo(field: keyof Estadistica, valor: any): Promise<void> {
        try {
            await this.firestoreService.updateDoc('estadisticas', 'estadisticasGenerales', {
                [field]: valor
            });
        } catch (error) {
            console.error(`[EstadisticasService] Error al setear campo "${field}":`, error);
            throw error;
        }
    }

    // ➕ Incrementar campo numérico
    async incrementarCampo(field: keyof Estadistica, valor: number = 1): Promise<void> {
        try {
            await this.firestoreService.incrementField('estadisticas/estadisticasGenerales', field as string, valor);
        } catch (error) {
            console.error(`[EstadisticasService] Error al incrementar campo "${field}":`, error);
            throw error;
        }
    }
}
